__turbopack_context__.v({
  "button": "bottom-panel-module-scss-module__rQn9OG__button",
  "buttonGroup": "bottom-panel-module-scss-module__rQn9OG__buttonGroup",
  "centerGroup": "bottom-panel-module-scss-module__rQn9OG__centerGroup",
  "container": "bottom-panel-module-scss-module__rQn9OG__container",
  "desktopContainer": "bottom-panel-module-scss-module__rQn9OG__desktopContainer",
  "leftGroup": "bottom-panel-module-scss-module__rQn9OG__leftGroup",
  "metLogo": "bottom-panel-module-scss-module__rQn9OG__metLogo",
  "mobileContainer": "bottom-panel-module-scss-module__rQn9OG__mobileContainer",
  "mobileReadingToolsTrigger": "bottom-panel-module-scss-module__rQn9OG__mobileReadingToolsTrigger",
  "readingToolsOption": "bottom-panel-module-scss-module__rQn9OG__readingToolsOption",
  "readingToolsOptionTrigger": "bottom-panel-module-scss-module__rQn9OG__readingToolsOptionTrigger",
  "readingToolsOptions": "bottom-panel-module-scss-module__rQn9OG__readingToolsOptions",
  "rightGroup": "bottom-panel-module-scss-module__rQn9OG__rightGroup",
  "title": "bottom-panel-module-scss-module__rQn9OG__title",
});
